module.exports = __webpack_public_path__ + "img/grabpay.a5359c0c.png";